const ScopeComponent = (Component) => {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"7b584a0"}`, "");
  });
};
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-B97avXP9.mjs.map
